<div class="modal notification">
	<div class="modal-content">
		<i class="icon-close" (click)="close.emit()"></i>
		<h1 class="title">
			<ng-content select="[title]"></ng-content>
		</h1>
		<ng-content select="[body]"></ng-content>
	</div>
</div>
